<template>
  <SmartLink :route="route" class="header-logo">
    <UkaskoLogo
      class="header-logo-icon"
      :width="150"
      :height="27"
    />
  </SmartLink>
</template>

<script>
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    route: {
      type: Object,
      required: true,
    }
  },
  components: { UkaskoLogo, SmartLink },
};
</script>

<style lang="scss" scoped>
.header-logo {
  display: block;

  &-icon {
    margin: 0 9px;
  }
}
</style>
